import { log } from '..';

/* eslint-disable func-names */

const Debouncer = function (props) {
  const {
    timeoutMs = 100,
    lastOnly,
    delayMs
  } = props || {};
  const defaultCallback = () => null;
  const tryCallback = callback => {
    /* Put callback in try catch in case there's an error it doesn't stop code execution */
    try {
      callback();
    } catch (error) {
      log.warn('Error invoking debouncer callback:', error);
    }
  };
  this.checkAwaitingUpdate = timeoutIndex => {
    // log.trace(
    //     'this.updateCallback:', this.updateCallback, 'this.timeout:', this.timeout,
    //     'timeoutIndex:', timeoutIndex, 'this.timeoutIndex:', this.timeoutIndex,
    // );
    const callback = this.updateCallback;
    const currentIndex = this.timeoutIndex;
    if (callback) {
      /** Invoke callback if not lastOnly, or if lastOnly and timeoutIndex is current,
       * or if no timeout index (presumably called externally to force checking update)) */
      if (!lastOnly || (timeoutIndex || this.timeoutIndex) === this.timeoutIndex) {
        this.updateCallback = null;
        tryCallback(callback);
      }
      setTimeout(() => this.checkAwaitingUpdate(currentIndex), timeoutMs);
    } else {
      this.timeout = false;
      // if (!lastOnly) {
      //     /* If this.updateCallback got set in the last couple lines, check update immediately */
      //     setTimeout(() => { if (this.updateCallback) this.checkAwaitingUpdate(currentIndex); }, 0);
      // }
    }
  };
  this.timeout = false;
  this.timeoutIndex = 1;
  this.updateCallback = null;
  this.update = callback => {
    this.timeoutIndex += 1;
    const currentIndex = this.timeoutIndex;
    if (this.timeout || delayMs) {
      /* Already have a timeout, so just set updateCallback and the previous this.checkAwaitingUpdate will use latest update */
      this.updateCallback = callback || defaultCallback;
      /* Check if this.updateCallback got cleared immediately in this.checkAwaitingUpdate */
      // setTimeout(() => { if (!this.updateCallback) this.updateCallback = callback || defaultCallback; }, 0);
      if (lastOnly) {
        setTimeout(() => this.checkAwaitingUpdate(currentIndex), this.timeout ? timeoutMs : delayMs);
      }
    } else {
      this.timeout = true;
      tryCallback(callback);
      setTimeout(() => this.checkAwaitingUpdate(currentIndex), timeoutMs);
    }
  };
};
export default Debouncer;